import { render, staticRenderFns } from "./DictionarySelector.vue?vue&type=template&id=10547d68&scoped=true"
import script from "./DictionarySelector.vue?vue&type=script&lang=js"
export * from "./DictionarySelector.vue?vue&type=script&lang=js"
import style0 from "./DictionarySelector.vue?vue&type=style&index=0&id=10547d68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10547d68",
  null
  
)

export default component.exports